import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveUrl } from "~/utils/url/urlResolver";
import { type CaseDataObject } from "~/features/orders/orderDetails/components/ServiceCases/types";

const baseUrl = "/feedback";

export async function fetchServiceCases(soNumber: string) {
  const apiUrl = resolveUrl(`${baseUrl}/fetch?orderNumber=${soNumber}`);
  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    method: "GET",
  });

  try {
    return await response.json();
  } catch (err) {
    console.error(err);
    return undefined;
  }
}

export async function fetchServiceCasesByLineNumber(soNumber: string, lineNumber: string): Promise<CaseDataObject[]> {
  const apiUrl = resolveUrl(`${baseUrl}/fetch?orderNumber=${soNumber}&orderLineNumber=${lineNumber}`);
  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    method: "GET",
  });

  return await response.json();
}

export async function addCommentByCode(code: string, message: string) {
  const apiUrl = resolveUrl(`${baseUrl}/update`);
  const response = await fetch(apiUrl, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    method: "POST",
    body: JSON.stringify({
      code: code,
      feedbackMessage: message,
    }),
  });
  return await response;
}
